import { combineReducers } from '@reduxjs/toolkit'
import abApi from '../api/rtkQuery/abApi'
import addonsApi from '../api/rtkQuery/addonsApi'
import analyticsApi from '../api/rtkQuery/analyticsApi'
import { bookConfirmApi } from '../api/rtkQuery/bookConfirmApi'
import { calendarApi } from '../api/rtkQuery/calendarApi'
import countryApi from '../api/rtkQuery/countryApi'
import { couponApi } from '../api/rtkQuery/couponApi'
import currencyApi from '../api/rtkQuery/currencyApi'
import fareFamilyApi from '../api/rtkQuery/fareFamilyApi'
import fareFamilyApiV3 from '../api/rtkQuery/fareFamilyApiV3'
import fetchBookingDetailsApi from '../api/rtkQuery/fetchBookingDetailsApi'
import itineraryApi from '../api/rtkQuery/itineraryApi'
import SrpFareFamilyApi from '../api/rtkQuery/srpFareFamilyApi'
import SRPFlightDetailsApi from '../api/rtkQuery/srpFlightDetailsApi'
import SrpFlightResultsApi from '../api/rtkQuery/srpFlightResults'
import tagsApi from '../api/rtkQuery/tagsApi'
import tripListApi from '../api/rtkQuery/tripListApi'
import userApi from '../api/rtkQuery/userApi'
import walletApi from '../api/rtkQuery/walletApi'
import homepageUSPApi from '../api/rtkQuery/homepageUSPApi'
import giftVoucherApi from '../api/rtkQuery/giftVoucherApi'
import shukranApi from '../api/rtkQuery/shukranApi'
import offersApi from '../api/rtkQuery/offersApi'
import popularAirportApi from '../api/rtkQuery/popularAirport'
import profileApi from '../api/rtkQuery/profileApi'
import { authApi } from '../services/authApi'
import { otpAuthApi } from '../services/otpAuthApi'
import { userDetailsApi } from '../services/userDetailsApi'
import authReducer from './slices/authSlice'
import currencyReducer from './slices/currencySlice'
import itineraryReducer from './slices/itinerarySlice'
import srpReducer from './slices/srpStatesSlice'

const rootReducer = combineReducers({
    srp: srpReducer,
    itinerary: itineraryReducer,
    auth: authReducer,
    currency: currencyReducer,
    [itineraryApi.reducerPath]: itineraryApi.reducer,
    [currencyApi.reducerPath]: currencyApi.reducer,
    [fareFamilyApi.reducerPath]: fareFamilyApi.reducer,
    [fareFamilyApiV3.reducerPath]: fareFamilyApiV3.reducer,
    [couponApi.reducerPath]: couponApi.reducer,
    [calendarApi.reducerPath]: calendarApi.reducer,
    [countryApi.reducerPath]: countryApi.reducer,
    [addonsApi.reducerPath]: addonsApi.reducer,
    [SRPFlightDetailsApi.reducerPath]: SRPFlightDetailsApi.reducer,
    [SrpFareFamilyApi.reducerPath]: SrpFareFamilyApi.reducer,
    [SrpFlightResultsApi.reducerPath]: SrpFlightResultsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [otpAuthApi.reducerPath]: otpAuthApi.reducer,
    [userDetailsApi.reducerPath]: userDetailsApi.reducer,
    [bookConfirmApi.reducerPath]: bookConfirmApi.reducer,
    [fetchBookingDetailsApi.reducerPath]: fetchBookingDetailsApi.reducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [tagsApi.reducerPath]: tagsApi.reducer,
    [tripListApi.reducerPath]: tripListApi.reducer,
    [abApi.reducerPath]: abApi.reducer,
    [walletApi.reducerPath]: walletApi.reducer,
    [homepageUSPApi.reducerPath]: homepageUSPApi.reducer,
    [giftVoucherApi.reducerPath]: giftVoucherApi.reducer,
    [shukranApi.reducerPath]: shukranApi.reducer,
    [offersApi.reducerPath]: offersApi.reducer,
    [popularAirportApi.reducerPath]: popularAirportApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
